import {makeGetRequest} from "@/api/helpers";

/**
 * Get dictionaries.
 */
export const getDictionaries = async () => {
    const result = await makeGetRequest('/api/dictionaries/');

    return result.data;
};